export default "__VITE_ASSET__Dn4VydKt__"